module.exports = __webpack_public_path__ + "img/only-gold-bg.9c5e654.png";